// Базовые стили идут первыми: стили экранов, подключённые самими экранами, уточняют их.
import './styles/base.css';
import './styles/tile.css';
import './styles/shell.css';
import './styles/storefront.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ApiError, resolveBackend } from './api/client.ts';
import { App } from './app.tsx';
import { installDemoBridge } from './demo-bridge.ts';
import { currentLang } from './i18n/index.ts';
import { startWiring } from './state/wiring.ts';

/**
 * Запросы не повторяются на ошибках прав и валидации: повтор вернёт то же самое.
 * Живые данные приходят лентой событий; экраны перечитывают свои запросы по ней.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (attempt, error) => {
        if (error instanceof ApiError && error.status > 0 && error.status < 500) return false;
        return attempt < 1;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
    mutations: { retry: false },
  },
});

installDemoBridge();
document.documentElement.lang = currentLang();

const root = document.getElementById('root');
if (!root) throw new Error('Нет элемента #root');

// Адрес API выбирается до первого запроса: от него зависят токен и все данные экрана.
void resolveBackend().then(() => {
  startWiring();
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
